import {useSelector} from 'react-redux';

/**
 * The current logged-in user.
 * @returns {Object} The current user.
 */
export const useCurrentUser = () => useSelector(state => state.user.user);
